<template>
  <div class="columns">
    <div class="column is-half is-offset-one-quarter">
      <div class="notification is-danger">
        <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
        {{ message }}...
        <hr>
        <div class="control">
          <button class="button is-danger is-inverted" @click="$router.back()">Terug</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Toegang geweigerd'
    }
  }
}
</script>

<style scoped>
  .notification {
    top: 50%;
  }
</style>
